export default class TestingQuestionTextResult {
  public readonly id!: string;
  public readonly assignment_question_id!: string;
  public readonly text_version_id!: string;

  public value?: string;
}
